import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import { findAllOrderListLiveGroupByClientEvent } from '../../../_events/order_list_view/find.event';

const style = {
  position: 'absolute',
  marginTop: '50px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ClientModalOrders(props) {
    const { client } = props;
    const [open, setOpen] = React.useState(false);
    const [balance, setBalance] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const loadClientPB = () => {
        setLoading(true);
        findAllOrderListLiveGroupByClientEvent(client.uuid)
        .then(json => {
            setBalance(json.data?.detailsGroup);
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);            
        });
    }

    const handleOpen = () => {
        if(client){
            loadClientPB()
            setOpen(true);
        }        
    };

    const handleClose = () => {
        setOpen(false);
        props.closeParent();
    };

    return (
        <div>
            <Button variant='contained' size='small' onClick={handleOpen}>Ver pedidos</Button>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
            <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'column', width: '80%'}}>
                    <strong>
                        Pedidos de:
                    </strong>
                    <span>{client ? client.name : ''}</span>
                </div>                
                <div style={{display: 'flex', flexDirection: 'row-reverse', width: '20%'}}>
                    <Button size='small' onClick={handleClose}>Cerrar</Button>
                </div>
            </div>            
            {
                loading ? (
                    <PrimaryProgress />
                ) : (
                    <>
                    {
                       balance.length === 0 ? (
                        <>No hay reporte de pedidos para este cliente</>
                       ) : (
                        <div style={{width: '100%'}}>
                            <div style={{width: '100%'}}>
                            <table style={{width: '100%'}}>
                                <thead style={{width: '100%'}}>
                                    <tr>
                                        <th style={{ width: '10%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Pedido</th>
                                        <th style={{ width: '15%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Fecha</th>
                                        <th style={{ width: '26%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Descripción</th>
                                        <th style={{ width: '13%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Cantidad</th>
                                        <th style={{ width: '13%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Pendiente</th>
                                        <th style={{ width: '13%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Reservado</th>
                                        <th style={{ width: '13%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Despachado</th>
                                    </tr>
                                </thead>
                            </table>
                            </div>
                            <div style={{width: '100%', overflowY: 'auto', height: '500px'}}>
                            {
                                balance.map((d, key) => {
                                    let date = d.date_created ? new Date(d.date_created) : null;
                                    let dateRep = date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : 'NA';
                                    return(
                                        <table key={`table_stateorder_seller_${key}`} style={{width: '100%'}}>
                                            <tbody style={{width: '100%'}}>
                                                <tr>
                                                    <th style={{ width: '10%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.order} OC:${d.purchase_order}`}</th>
                                                    <th style={{ width: '15%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{dateRep}</th>
                                                    <th style={{ width: '26%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.ref} Elástico ${d.color}`}</th>
                                                    <th style={{ width: '13%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.quantity}`}</th>
                                                    <th style={{ width: '13%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.pend}`}</th>
                                                    <th style={{ width: '13%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.reser}`}</th>
                                                    <th style={{ width: '13%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.despa}`}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    )
                                })
                            }
                            </div>
                        </div>
                       )
                    }
                    </>
                )
            }
            </Box>
        </Modal>
        </div>
    );
}